jQuery(document).ready(function($) {

  /* ACCORDION SCRIPTS ------------------------------------------ */
  $('.singular-accordion').each(function() {

    var $accordion = $(this);

    $('.accordion-item', $accordion).each(function() {

      var $item = $(this);
      var $title_wrap = $('.accordion-item-title > div', $item);
      var $content_wrap = $('.accordion-item-content', $item);
      var $content_content = $('> div', $content_wrap);

      $title_wrap.append('<button class="toggle"><span class="title">Toggle</span><span class="close"><span class="svg-icon arrow-long-down"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 24" role="img" aria-label="Arrow Long Down"><title>Arrow Long Down</title><g class="wrap" transform="translate(22 24) rotate(180)"><path class="no-stroke" d="M11,0,22,24H0Z"/><path class="arrow" d="M 11 4.800138473510742 L 3.116729736328125 22 L 18.88327026367188 22 L 11 4.800138473510742 M 11 0 L 22 24 L 0 24 L 11 0 Z"/></g></svg></span></span></button>').on('click', function() {
        
        if ($item.hasClass('open')) {

          $content_wrap.css('max-height','');
          $item.removeClass('open');

        } else {

          var content_height = $content_content.innerHeight() + 'px';
          $content_wrap.css('max-height',content_height);
          $item.addClass('open');

        }

      });

    });

    $(window).on('resize', function() {

      $('.accordion-item.open').each(function() {

        var $content_wrap = $('.accordion-item-content', this);
        var $content_content = $('> div', $content_wrap);
        var content_height = $content_content.innerHeight() + 'px';
        $content_wrap.css('max-height',content_height);

      });

    });

  });

});
